import { useEffect, useState } from "react";
import { UserInfo } from "../../Models/userInfo";
import { GetActivityCounter, GetActivityVoiceWaiting, UpdateActivityVoiceWaiting, sendActivity, startForm } from "../../Utils/botUtils";
import { useAjadi } from "../Context/AjadiContext";
import { RetorikEvent, useRetorikEvent } from "@davi-ai/retorik-framework";

const BotCustomEventListenner = () => {
  const ajadi = useAjadi();
  const  retorikEvent  = useRetorikEvent();
  // const { retorikEvent } = useUtilsStore()
    useEffect(()=>{
        document.addEventListener('keydown', (event) => {
          const keyName = event.key;
        
          if (keyName === 'Control') {
            return;
          }
          if(event.ctrlKey && keyName==="*"){
            sendActivity({
              type:"event",
              name: 'continueDialog',
            });
          }
        }, false);
      },[])

       useEffect(()=> {
         console.log("retorikEvent", retorikEvent)
        if(retorikEvent === RetorikEvent.SpeechEnded) UpdateActivityVoiceWaiting(false)
       }, [retorikEvent])
      
    useEffect(() => {
      
        const handleEventListerner = async (e : any) => {
            let customEvent: CustomEvent = e as CustomEvent;
            if (customEvent.detail) {
                console.log(customEvent.detail);
                if(customEvent.detail?.name === "Event_Start"){
                    //Trigger start form
                    console.log("###Event_Start ")
                    let retreiveHistory : boolean = localStorage.getItem("retreiveHistory") === 'true';
                    if(retreiveHistory){
                      startForm("2.1 Accueil User");
                    }
                    else{
                      startForm("1.1 Présentation de Vicky");
                    }
                }

                if (customEvent.detail.name === "AJADI_Event_setUserInfo") {
                  if(customEvent.detail.value?.gender && customEvent.detail.value?.voice){
                    let userInfo : UserInfo = {
                      gender : customEvent.detail.value.gender,
                      voice : customEvent.detail.value.voice
                    };
                    console.log("set user info :", userInfo)
                    ajadi.setUserInfo(userInfo);
                  }
               }
               if(customEvent.detail.name ==="AJADI_Event_ResetUserInfo"){
                  ajadi.setUserInfo(undefined)
               }
               if(customEvent.detail.name === "AJADI_Questionnaire"){
                if(window){
                  window.open("questionnaire", '_blank')?.focus();
                }
              }
              if(customEvent.detail.name === "AJADI_SetVoiceMode"){
                let defaultMode : number = ajadi.defaultMode;
                defaultMode=1
                ajadi.setDefaultMode(defaultMode)
                const host = document.querySelector("#retorik-shadow");
                (host?.shadowRoot?.querySelector("[aria-label=vocal]") as HTMLElement)?.click()
              }

              if(customEvent.detail.name === "AJADI_WaitingActivitySpeakEnd"){
                var intr1 = setInterval(function() {
                  console.log("Wait voice to finish")
                  let voiceWaiting = GetActivityVoiceWaiting()
                  if(!voiceWaiting){
                    console.log("Voice to finished ! Send next")
                      sendActivity({
                        type: "event",
                        name: "continueDialog",
                        //value: "voiceFinish",
                      });
                      clearInterval(intr1);
                    }
                }, 500)
              }

              if(customEvent.detail?.name === "GetUserCompany"){
                  //Get user Age & Sex
                    let company : string= ajadi.retorikConfig?.userData?.company ?? ""
                    
                    //send activity only if all previous activities are fulfilled
                    var intr = setInterval(function() {
                        let numberOfActivityPending = GetActivityCounter()
                        if(numberOfActivityPending === 0){
                            sendActivity({
                                type:"event",
                                name: 'SendCompany',
                                value: {
                                    "Company" : company
                                }
                            });
                            clearInterval(intr);
                        }
                      }, 500)
                      
              }
              if(customEvent.detail?.name === "GetUserMail"){
                //Get user Age & Sex
                
                    let mail : string= ajadi.retorikConfig?.userData?.mail ?? ""
                    
                    //send activity only if all previous activities are fulfilled
                    var intr2 = setInterval(function() {
                        let numberOfActivityPending = GetActivityCounter()
                        if(numberOfActivityPending === 0){
                            sendActivity({
                                type:"event",
                                name: 'SendMail',
                                value: {
                                    "Mail" : mail
                                }
                            });
                            clearInterval(intr2);
                        }
                      }, 500)
                    
                
              }

              if(customEvent.detail?.name === "GetUserData"){
                var intr3 = setInterval(function() {
                  let numberOfActivityPending = GetActivityCounter()
                  if(numberOfActivityPending === 0){
                      let dataJson = localStorage.getItem("dataToRetreive")
                      if(dataJson){
                        let data = JSON.parse(dataJson);
                        sendActivity({
                            type:"event",
                            name: 'SendUserData',
                            value: data
                        });
                      }
                      clearInterval(intr3);
                  }
                }, 500)
              }

            }
        }
        
        document.addEventListener("ChatbotEvent", handleEventListerner);
        return () => {
            document.removeEventListener("ChatbotEvent", handleEventListerner);
        };
    },[]);

    return null;
}

export {
    BotCustomEventListenner
}